import { TypedStoreConfig } from '../factories/store';
import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

const EducatorSpaceCardsModel = TypedStoreConfig({
    modelName: 'EducatorSpaceCardsModel',
    properties: {
        id: types.string,
        section_id: types.string,
        title: types.string,
        description: types.string,
        icon: types.string,
        ctaLabel: types.string,
        fileURL: types.string,
        requiredPermission: types.string, // See Permission type
    },
});

export type TypeEducatorSpaceCardsModel = Instance<typeof EducatorSpaceCardsModel>;

export default EducatorSpaceCardsModel;
